import React from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Chat from "./pages/Chat";
import ProfileModel from "./pages/Profile";
import { ProfileThemeProvider } from "./components/ProfileThemeProvider";
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <ProfileThemeProvider>
        <div className="container">
          <nav className="navigation">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/chat" className="nav-link">Chat</Link>
            <Link to="/profile" className="nav-link">Profile</Link>
          </nav>
          <Switch>
            <Route path="/chat" component={Chat} />
            <Route path="/profile" component={ProfileModel} />
            <Route path="/" exact>
              <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
              				<ul>
				   <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</li>
				   <li>Aliquam tincidunt mauris eu risus.</li>
				   <li>Vestibulum auctor dapibus neque.</li>
				</ul>
						 
            </Route>
          </Switch>
        </div>
      </ProfileThemeProvider>
    </Router>
  );
};

export default App;
